//@flow

import {useSelector} from 'react-redux';
import type {Currency} from '../../../entities';
import type {RootState} from '../../index';

const currenciesSelector = (state: RootState) =>
  state.currency && state.currency.currencies;

const currencySelector = (state: RootState) =>
  state.currency && state.currency.currency;

export function useCurrencies() {
  const currencies = useSelector(currenciesSelector);
  return currencies;
}

export function useStoreCurrency(): Currency | typeof undefined {
  const currency = useSelector(currencySelector);
  return currency;
}
